<template>
    <Button
        color="carbon-400"
        size="l"
        leftIcon="chevron-left"
        :aria-label="$tr('gameContainer.back')"
        interfaceTarget="game-back-button"
        :class="$style.button_override"
        @click="goBack"
    />
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'

import Button from '@/components/Buttons/Button.vue'
import { ROUTE_NAMES } from '@/router/constants'

const router = useRouter()

function goBack() {
    if (router.options.history.state.back) {
        router.back()
    } else {
        router.push({ name: ROUTE_NAMES.MAIN })
    }
}
</script>

<style module>
.button_override {
    --background-color: var(--white-08);
    --border-width: 1px;
    --border-color: var(--white-08);
    padding: 12px;
    flex-shrink: 0;
}
</style>
